<template>
  <div>
    <div class="mb-3">
      <label>Qərar nəticəsi</label>
      <el-select v-model="form.decisionResult" size="large" placeholder="Seçin">
        <el-option label="Tam təmin olundu" :value="1" />
        <el-option label="Qismən təmin olundu " :value="2" />
        <el-option label="Təmin olunmadı" :value="3" />
      </el-select>
    </div>
    <div class="mb-3">
      <label>Qərar tarixi</label>
      <el-date-picker 
        v-model="form.decisionDate"
        size="large"
        type="date"
        format="DD.MM.YYYY"
        value-format="YYYY-MM-DD"
        style="width: 100%"
      />
    </div>
    <div class="mb-3">
      <label>Məbləğ</label>
      <el-input
        v-model="form.decisionAmount"
        size="large"
        type="number"
        style="width: 100%"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: Object
  },
  computed: {
    form: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      }
    }
  }
};
</script>
